

























import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import Element from 'element-ui'
import { showVaildMsg } from '@/configs/validate'

@Component
export default class PageForm extends Vue {
  public name = 'PageForm'

  @Prop({ default: false })
  public loading: any = false
  //  label-width="160px"
  @Prop({ default: '200px' })
  public labelWidth: string = '200px'
  @Prop({ default: null })
  public form!: any
  @Prop({ default: null })
  public rules!: any
  //:cancel="function"
  @Prop({ default: null })
  public cancel!: () => void
  @Prop({ default: null })
  //:submit="function"
  public submit!: () => void

  public $refs!: {
    pageForm: Element.Form
  }
  public clearValidate() {
    this.$nextTick(() => {
      if (this.$refs.pageForm) {
        this.$refs.pageForm.clearValidate()
      }
    })
  }
  public validate(): boolean {
    let result = true
    this.$refs.pageForm.validate((valid: boolean, obj: any) => {
      if (valid) {
        result = true
      } else {
        showVaildMsg(this.$message, obj)
        result = false
      }
    })
    return result
  }
  public validateField(field: string | string[]) {
    var msg = ''
    this.$refs.pageForm.validateField(field, (m) => {
      if (m != '') {
        msg = m
      }
    })
    return msg
  }
  public getForm() {
    return this.$refs.pageForm
  }
  public doSubmit() {
    if (this.validate()) {
      if (this.submit) {
        this.submit()
      }
    }
  }
}
